import { IFormData, ILineItemField } from "../../EditInvoice"
import React, { useContext } from "react"
import { AdminContext } from "../../../../../contexts/AdminContext"
import classNames from "../../../../../utils/classNames"
import LineItemRow from "./LineItemRow"
import { SiteProps } from "../../../../../interfaces"
import MobileLineItemRow from "./MobileLineItemRow"

interface MobileLineItemsTableProps {
  resource: IFormData
  items: ILineItemField[]
  isForPrint: boolean
  isPreview: boolean
  site: SiteProps
}

const MobileLineItemsTable = ({ resource, items, isForPrint, isPreview, site }: MobileLineItemsTableProps) => {
  const { camp } = useContext(AdminContext)

  if (isForPrint) {
    return <></>
  }

  if (isPreview) {
    return (
      <div className={classNames("overflow-hidden block mdlg:hidden")} style={{ maxWidth: "95vw" }}>
        <div style={{ minWidth: "auto" }}>
          <div
            className={classNames(
              "grid gap-2 font-bold mb-2.5 text-baselg pb-1.5 border-b border-gray-900 grid-cols-2 custom-500:grid-cols-4 w-full",
            )}
          >
            <div>Item</div>
            <div className="col-span-1 hidden custom-500:block">Price</div>
            <div className="col-span-1 hidden custom-500:block">Quantity</div>
            <div>Amount</div>
          </div>
          {items?.map((item, index) => (
            <LineItemRow
              camp={camp}
              key={index}
              index={index}
              item={{ ...item, is_hidden: isForPrint ? item.unit_amount == 0 : item.is_hidden }}
              isPreview={isPreview}
              site={site}
              isRecurring={false}
            />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="block mdlg:hidden">
      {items?.map((item, index) => (
        <MobileLineItemRow
          camp={camp}
          key={index}
          index={index}
          item={{ ...item, is_hidden: isForPrint ? item.unit_amount == 0 : item.is_hidden }}
          isPreview={isPreview}
          site={site}
          isRecurring={false}
        />
      ))}
    </div>
  )
}

export default MobileLineItemsTable
